/**
 * Seeded pseudo-random number generator (mulberry32 variant).
 * Used by Geo and Poster family generators.
 *
 * Usage:
 *   const rand = createRandom(42);
 *   rand();  // => 0.0–1.0
 */

export function createRandom(seed) {
  let s = Math.abs(seed) || 1;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

/** Pick a random element from an array */
export function pick(arr, rand) {
  return arr[Math.floor(rand() * arr.length)];
}

/** Random integer in [a, b) */
export function randInt(a, b, rand) {
  return Math.floor(a + rand() * (b - a));
}

/** Fisher-Yates shuffle (returns new array) */
export function shuffle(arr, rand) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
